import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { useDashboardData } from '../components/DashboardShell';
import { useLocale } from '../context/LocaleContext';
import './Dashboard.css';

function Analytics() {
  const { data, loading } = useDashboardData();
  const { t } = useLocale();
  if (!data && loading) return null;

  const { analytics } = data;
  const analyticsData = analytics?.metrics || [];
  const topQuestions = analytics?.topQuestions || [];

  return (
    <>
      <div className="stats-grid">
        {analyticsData.map((item, index) => (
          <div key={item.metric || index} className="stat-card stat-card--lift">
            <div className="stat-icon stat-icon--lucide" aria-hidden>
              {item.trend === 'up' ? (
                <TrendingUp size={26} strokeWidth={1.75} />
              ) : (
                <TrendingDown size={26} strokeWidth={1.75} />
              )}
            </div>
            <div className="stat-content">
              <p className="stat-label">{item.metric}</p>
              <h3 className="stat-value">{item.value}</h3>
              <p className={`stat-change ${item.trend === 'up' ? 'positive' : 'negative'}`}>
                {item.change} {t('analytics.vsLastPeriod')}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="section section--lift">
        <h2>{t('analytics.mostAsked')}</h2>
        <div className="analytics-questions">
          {topQuestions.map((item, index) => (
            <div key={item.question || index} className="analytics-question-row">
              <div className="analytics-question-row__top">
                <span className="analytics-question-row__q">{item.question}</span>
                <span className="analytics-question-row__count">{t('analytics.times', { n: item.count })}</span>
              </div>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${Math.min(100, item.percentage || 0)}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="section section--lift section--chart-placeholder">
        <h2>{t('analytics.perfOverTime')}</h2>
        <div className="chart-placeholder">{t('analytics.chartHint')}</div>
      </div>
    </>
  );
}

export default Analytics;
